import React from "react";
import { getShortTitle } from "common/menuTypes";

const MenuTypeDisplay = ({ medical }: { medical: boolean }) => (
  <div className="px-md py-sm text-sm rounded bg-leafly-white text-black">
    {getShortTitle(medical)} only
  </div>
);

export default MenuTypeDisplay;
